export const PAYRUN_INTEGRATION_SETTING_SUCCESS =
  "Pay Runs integration setting updated successfully.";
export const AMENDMENT_INTEGRATION_SETTING_SUCCESS =
  "Amendments integration setting updated successfully.";
export const REPORTS_INTEGRATION_SETTING_SUCCESS =
  "Reports integration setting updated successfully.";
